function emitWarning() {
    if (!emitWarning.warned) {
      emitWarning.warned = true;
      console.log(
        'Deprecation (warning): Using file extension in specifier is deprecated, use "highlight.js/lib/languages/isbl" instead of "highlight.js/lib/languages/isbl.js"'
      );
    }
  }
  emitWarning();
    module.exports = require('./isbl.js');